//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




import axios from "axios";


export default {

    props: {
        /*
        * Profile - only used for localstorage key
        */
        profile: {
            type: String,
            required: true,
        },
        /*
        * Instagram access token.
        */
        token: {
            type: String,
            required: true,
        },
        /*
        * Number of items per load.
        */
        count: {
            type: Number,
            default: 3,
            required: false,
        },
        /*
        * To Display the Load more button
        */
        displayLoadMore: {
            type: Boolean,
            default: true,
            required: false,
        },
    },

    data: () => ({
        feed: [],
        /*
        *  Number of feed load.
        */
        pageLoads: 1,
        fromCache: false,
        nextMaxId: '', // insta doesn't have an offset value for our load more, (instead we can pass it the max_id of an item which we get from the insta response), but insta also gives us the full url, so we'll just use that
        moreData: true,
    }),

    methods: {
        getUserFeed () {
            /* First check localstorage for data */

            var cachedTime = localStorage.getItem('instagramtime_'+ this.profile);

            let expiryInMinutes = 720; // 12 hours

            let fetchNewData = true;
            
            if (cachedTime !== undefined && cachedTime !== null && parseInt(cachedTime)+(expiryInMinutes * 60 * 1000) > new Date().getTime()) {

                console.log("now = ");
                console.log( new Date().getTime());
                console.warn("use cached version");
                console.log('cached time='+cachedTime);
                console.log(` cachedTime+(1 * 60 * 1000) ${parseInt(cachedTime)+(60 * 60 * 1000)}   > now`);

                console.log(`minutess time since last ${(parseInt(cachedTime)-  new Date().getTime() ) / 1000/60 }  `);

                var cachedInstagram = localStorage.getItem('instagram_'+ this.profile);
               
                if (cachedInstagram !== undefined && cachedInstagram !== null){
                    let cache =  JSON.parse(cachedInstagram);
                    this.feed = cache.feed;
                    this.nextMaxId =  cache.nextMaxId;
                    fetchNewData = false;
                    this.fromCache = true;
                }

            } 

            if(fetchNewData) { // Expired or localstorage data doesn't exist
                console.log(`minutess time since last ${(parseInt(cachedTime)-  new Date().getTime() ) / 1000/60 }  `);

                console.warn("EXPIRED or DATAT DOESNT EXIST");


                let _this = this;

                axios
                .get(`https://api.instagram.com/v1/users/self/media/recent`, { params: {access_token: this.token, count: this.count, max_id: this.nextMaxId} })
                .then(function(response) {

                    console.log(response);

                    _this.feed.push(...response.data.data);

                    if(response.data.pagination.next_max_id !== undefined)
                        _this.nextMaxId = response.data.pagination.next_max_id;
                    else
                        _this.moreData = false;

                    localStorage.setItem('instagram_'+ _this.profile, JSON.stringify({ 'feed': _this.feed, 'nextMaxId': _this.nextMaxId}));
                    localStorage.setItem('instagramtime_'+ _this.profile, new Date().getTime());
   
                })
                .catch(function(error) {
                    console.error(error);

                    /* just get whatever we have in localstorage if available */
                    console.log("Cannot get instagram: will try to retrieve from cache");
                    var cachedInstagram = localStorage.getItem('instagram_'+_this.profile);
               
                    if (cachedInstagram !== undefined && cachedInstagram !== null) {
                        let cache =  JSON.parse(cachedInstagram);
                        this.feed = cache.feed;
                        this.nextMaxId =  cache.nextMaxId;
                    }
   

                });

            }



            
        },
        fetchFeed () {
 
            console.log(`fetching insta data`);

            let _this = this;

            axios
            .get(`https://api.instagram.com/v1/users/self/media/recent`, { params: {access_token: this.token, count: this.count, max_id: this.nextMaxId} })
            .then(function(response) {

                _this.feed.push(...response.data.data);
 
                if(response.data.pagination.next_max_id !== undefined)
                    _this.nextMaxId = response.data.pagination.next_max_id;
                else
                    _this.moreData = false;

                localStorage.setItem('instagram_'+ _this.profile, JSON.stringify({ 'feed': _this.feed, 'nextMaxId': _this.nextMaxId }));
                localStorage.setItem('instagramtime_'+ _this.profile, new Date().getTime());

            })
            .catch(function(error) {
                console.error(error);
            });
            
        },
        loadMore() {
            this.pageLoads ++; // incrementing this will automatically show any extras already in cache

            // otherwise if no extra ones in cache or we did not originally get from cache fetch more
            if(!this.fromCache || this.feed.length < this.pageLoads * this.count ) {
                this.fetchFeed();
            }
        }, 
        imageStyle(img) {
            if (!img) return;
            return {
                'background-image': `url(${img})`,
            };
        },
        itemClass(type) {
            return "instagram-feed__item--"+type;
        },
            
    },
 
    created: function() {
        this.getUserFeed();
    },
    
}



// WEBPACK FOOTER //
// ./scripts/vue/InstagramFeed.vue